import {
  ServerAvailableProductsResponseType,
  GetAvailableProductsResponseType,
} from './types';

/* Explanation */
// When the transformer is called and the value is being retrieved from cache,
//   the response is already transformed, so this is a TS guard to help ensure,
//   we're transforming if it's a ServerResponseType
function isTransformed(
  value: ServerAvailableProductsResponseType | GetAvailableProductsResponseType
): value is GetAvailableProductsResponseType {
  return (
    Array.isArray(value) &&
    value[0] &&
    value[0].hasOwnProperty('companyInfo') &&
    value[0].companyInfo.hasOwnProperty('carrierName')
  );
}

export const transformAvailableProductsResponse = (
  response:
    | ServerAvailableProductsResponseType
    | GetAvailableProductsResponseType
): GetAvailableProductsResponseType => {
  if (isTransformed(response)) {
    return response;
  }
  return response.map(product => {
    return {
      productType: product.productType,
      productSegment: product.productSegment,
      companyInfo: {
        carrierName: product.companyInfo.carrier.name,
        mga: product.companyInfo.mga?.name || null,
      },
    };
  });
};
